import { AppVersionConstants } from '../constants';

export function appVersion(state = {}, action) {
  switch (action.type) {
    case AppVersionConstants.GETAPPVERSION_SUCCESS:
      return {
        ...state,
        data:action.objVersion
      };
    case AppVersionConstants.GETAPPVERSION_FAILURE:
      return {
          ...state,
          
      };
    case AppVersionConstants.GETAPPVERSION_REQUEST:
      return {};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/appVersion.reducer.js